var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 7.5H13.8333V5.83332C13.8333 2.6168 11.2166 0 8 0C4.78344 0 2.16668 2.6168 2.16668 5.83332V7.5H0.91668C0.686367 7.5 0.5 7.68637 0.5 7.91668V18.3334C0.5 19.2525 1.24746 20 2.16668 20H13.8334C14.7525 20 15.5 19.2525 15.5 18.3333V7.91668C15.5 7.68637 15.3136 7.5 15.0833 7.5ZM9.24758 16.204C9.26059 16.3216 9.22277 16.4396 9.14383 16.5279C9.06488 16.6162 8.95176 16.6667 8.83336 16.6667H7.16668C7.04828 16.6667 6.93516 16.6162 6.85621 16.5279C6.77727 16.4396 6.73941 16.3216 6.75246 16.204L7.01531 13.8404C6.58848 13.5299 6.33336 13.0387 6.33336 12.5C6.33336 11.5808 7.08082 10.8333 8.00004 10.8333C8.91926 10.8333 9.66672 11.5808 9.66672 12.5C9.66672 13.0387 9.4116 13.5299 8.98477 13.8404L9.24758 16.204ZM11.3333 7.5H4.66668V5.83332C4.66668 3.99535 6.16203 2.5 8 2.5C9.83797 2.5 11.3333 3.99535 11.3333 5.83332V7.5Z",
    fill: "#081D3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPassword);
export default __webpack_public_path__ + "static/media/login_password.481ee5e94e00d6d71901ec78c3055597.svg";
export { ForwardRef as ReactComponent };